import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {mapParseItem, mapParseList} from '@brunata-angular/util';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {ApiToken, apiTokenSchema, CreateApiToken, createApiTokenSchema} from './api-token.model';

@Injectable({
    providedIn: 'root',
})
export class ApiTokenService {
    baseUrl = `${environment.onlineServiceUrl}`;
    constructor(private http: HttpClient) {}
    getApiTokens(): Observable<ApiToken[]> {
        return this.http.get(`${this.baseUrl}/apitokens`).pipe(mapParseList(apiTokenSchema));
    }
    createToken(tokenName: string): Observable<CreateApiToken> {
        return this.http
            .post(`${this.baseUrl}/apitokens`, {tokenName: tokenName})
            .pipe(mapParseItem(createApiTokenSchema));
    }
    revokeToken(item: ApiToken): Observable<unknown> {
        return this.http.delete(`${this.baseUrl}/apitokens/${item.apiTokenId}`);
    }
}
